import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useHistory } from 'react-router';
import { Box, IconButton, Tooltip } from '@mui/material';
import { KeyboardArrowLeftOutlined } from '@mui/icons-material';
import { Header3 } from '../Typography';
import { ActionsContainer } from './PageHeader.styles';
const PageHeader = ({ title, actions }) => {
    const history = useHistory();
    const onBack = useCallback(() => {
        if (history.length <= 1) {
            history.push('/');
            return;
        }
        history.goBack();
    }, [history]);
    return (_jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', minWidth: 80, children: [_jsx(Tooltip, { title: 'Go back', children: _jsx(IconButton, { sx: { mr: 1 }, onClick: onBack, children: _jsx(KeyboardArrowLeftOutlined, {}) }) }), typeof title === 'string' ? _jsx(Header3, { noWrap: true, children: title }) : title] }), _jsx(ActionsContainer, { children: actions })] }));
};
export default memo(PageHeader);
